import { Box, Typography, CircularProgress, Card, CardContent } from '@mui/material';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

export default function WaitingRoom({ meetingTitle }) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      <Card sx={{ maxWidth: 400, textAlign: 'center' }}>
        <CardContent sx={{ p: 4 }}>
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              bgcolor: 'surface.light',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 3,
            }}
          >
            <HourglassEmptyIcon sx={{ fontSize: 40, color: 'warning.main' }} />
          </Box>

          <Typography variant="h5" sx={{ mb: 1 }}>
            Waiting to join
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            {meetingTitle || 'Meeting'}
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 3 }}>
            <CircularProgress size={24} />
            <Typography variant="body2" color="text.secondary">
              The host will let you in soon...
            </Typography>
          </Box>

          <Box
            sx={{
              p: 2,
              bgcolor: 'surface.dark',
              borderRadius: 2,
              border: '1px solid rgba(255,255,255,0.05)',
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Please wait while the host admits you to the meeting. Make sure your camera
              and microphone are ready.
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
